import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const rolePermissionDeleteApi = createAsyncThunk(
    'auth/rolePermissions/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.adminAction(`roles_permissions/roles/${id}`, 1))
            return response.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const rolePermissionDeleteSlice = createSlice({
    name: 'rolePermission delete',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(rolePermissionDeleteApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(rolePermissionDeleteApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(rolePermissionDeleteApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const rolePermissionDeleteReducer = rolePermissionDeleteSlice.reducer
